module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)4.6e48c701.jpg";